import React from "react"
import { format } from "timeago.js"
import { cn } from "design_system/libs"
import ProfileLabel from "@love-irish/community-profile-label"
import formatter from "design_system/utils/formatter"

export interface Profile {
  id?: string
  username: string
  slug?: string
  avatar?: {
    imageUrl?: string
  }
}

export interface ResourceMetaFooterProps {
  /** Profile who added/created the resource */
  profile?: Profile
  /** Creation timestamp */
  createdAt: string
  /** Publication timestamp (takes precedence over createdAt for display) */
  publishedAt?: string
  /** Last update timestamp */
  updatedAt: string
  /** Additional CSS classes */
  className?: string
  /** Custom content to display on the left side instead of "Added by..." */
  customContent?: React.ReactNode
}

export const ResourceMetaFooter: React.FC<ResourceMetaFooterProps> = ({
  profile,
  createdAt,
  publishedAt,
  updatedAt,
  className,
  customContent,
}) => {
  const addedDate = publishedAt || createdAt

  return (
    <div className={cn("p-4 border-t flex justify-between text-xs", className)}>
      {customContent !== undefined ? (
        customContent
      ) : (
        <>
          {profile && (
            <div className="flex gap-1 items-center">
              Added by
              <ProfileLabel profile={profile} className="ml-2" size="sm" />
              on
              <time
                title={new Date(addedDate).toLocaleString()}
                dateTime={addedDate}
                className="font-bold"
              >
                {formatter.shortDate(addedDate)}
              </time>
            </div>
          )}
          <span>
            Updated{" "}
            <time
              title={new Date(updatedAt).toLocaleString()}
              dateTime={updatedAt}
              className="font-bold"
            >
              {format(updatedAt)}
            </time>
          </span>
        </>
      )}
    </div>
  )
}

export default ResourceMetaFooter
